import {
  Module, VuexModule, getModule, Mutation, Action,
} from '@compassdigital/vuex-module-decorators';
import { User, Partner } from '@compassdigital/foodworks.ts.sdk';

import store from '@/store';
import FormatUtil from '../../util/Format';

interface IUserState {
  currentUser: User | null;
  currentPartner: Partner | null;
  currentRole: string | null;
}
@Module({
  dynamic: true,
  name: 'user',
  namespaced: true,
  store,
})
class UserModule extends VuexModule implements IUserState {
  public currentUser: User | null = null;

  public currentPartner: Partner | null = null;

  public currentRole: string | null = null;

  @Mutation
  public SET_CURRENT_USER(user: User | null) {
    this.currentUser = user;
  }

  @Mutation
  public SET_CURRENT_ROLE(role: string | null) {
    this.currentRole = role;
  }

  @Mutation
  public SET_CURRENT_PARTNER(partner: Partner | null) {
    this.currentPartner = partner;
  }

  get fullname() {
    if (this.currentUser && this.currentUser.name) {
      return `${this.currentUser.name.first} ${this.currentUser.name.last}`;
    }
    return '';
  }

  get formattedFullname() {
    return FormatUtil.getFormattedName(this.currentUser);
  }

  get userId() {
    if (this.currentUser && this.currentUser.id) {
      return `${this.currentUser.id}`;
    }
    return '';
  }

  @Action
  public clear() {
    this.SET_CURRENT_PARTNER(null);
    this.SET_CURRENT_USER(null);
    this.SET_CURRENT_ROLE(null);
  }
}

export default getModule(UserModule);
